import type {
  LocalizedText,
  SaveBoardEditorialRequestDto,
  BoardValidationIssueDto,
} from './generated/types.gen.ts';

export const BOARD_LANGUAGES = ['sk', 'cs', 'en'] as const;
export const BOARD_EDITORIAL_LIMITS = {
  reason: 80,
  title: 160,
  intro: 1000,
  prompt: 280,
  role: 80,
} as const;
export function boardLocalizedIssues(
  value: LocalizedText,
  field: string,
  limit: number,
): BoardValidationIssueDto[] {
  return BOARD_LANGUAGES.flatMap((language) => {
    const text = value?.[language];
    return typeof text !== 'string' || !text.trim() || Array.from(text.trim()).length > limit
      ? [
          {
            field,
            language,
            message: `${field}.${language}: required, maximum ${limit} characters`,
          },
        ]
      : [];
  });
}
export function validateBoardEditorial(
  kind: 'picks' | 'quiz',
  value: SaveBoardEditorialRequestDto,
): BoardValidationIssueDto[] {
  const issues: BoardValidationIssueDto[] = [];
  const missing = (field: string, message: string) =>
    issues.push({ field, language: null, message });
  if (kind === 'picks') {
    if (!value.items.length) missing('items', 'Add at least one catalogue work');
    value.items.forEach((item, index) => {
      if (!item.workId) missing(`items[${index}].workId`, 'Choose a catalogue work');
      issues.push(
        ...boardLocalizedIssues(
          item.reason,
          `items[${index}].reason`,
          BOARD_EDITORIAL_LIMITS.reason,
        ),
      );
    });
  } else {
    issues.push(
      ...boardLocalizedIssues(value.title, 'title', BOARD_EDITORIAL_LIMITS.title),
      ...boardLocalizedIssues(value.intro, 'intro', BOARD_EDITORIAL_LIMITS.intro),
    );
    if (!value.hostId) missing('hostId', 'Choose a Belore team host');
    if (value.questions.length < 3 || value.questions.length > 4)
      missing('questions', 'A quiz needs 3–4 questions');
    value.questions.forEach((question, index) => {
      issues.push(
        ...boardLocalizedIssues(
          question.prompt,
          `questions[${index}].prompt`,
          BOARD_EDITORIAL_LIMITS.prompt,
        ),
      );
      if (question.options.length !== 4 || question.options.some((option) => !option.workId))
        missing(`questions[${index}].options`, 'Each question needs exactly 4 catalogue works');
      if (new Set(question.options.map((option) => option.workId)).size !== question.options.length)
        missing(`questions[${index}].options`, 'Choose different works within each question');
    });
  }
  return issues;
}
